import type { BoxSlotDraftEntity } from "@/modules/boxSlot/entities/boxSlotEntity"
import { create } from "@/modules/core/store"

type BoxPlanningStoreActions = {
  addBoxSlotsBeingCreated: (boxSlotDraft: BoxSlotDraftEntity) => void
  updateBoxSlotsBeingCreated: (boxSlotDraft: BoxSlotDraftEntity) => void
  clearBoxSlotsBeingCreated: () => void
  addBoxSlotViewed: (boxSlotViewed: string) => void
  removeBoxSlotViewed: () => void
}

type BoxPlanningStoreState = {
  boxSlotsBeingCreated: BoxSlotDraftEntity[]
  boxSlotsBeingViewed: string | null
  actions: BoxPlanningStoreActions
}

const useBoxPlanningStore = create<BoxPlanningStoreState>()((set) => ({
  boxSlotsBeingCreated: [],
  boxSlotsBeingViewed: null,
  actions: {
    addBoxSlotsBeingCreated: (boxSlotDraft: BoxSlotDraftEntity) => {
      set((state) => {
        const existingDraftIndex = state.boxSlotsBeingCreated.findIndex((draft) => draft.id === boxSlotDraft.id)
        if (existingDraftIndex === -1) {
          return { boxSlotsBeingCreated: [...state.boxSlotsBeingCreated, boxSlotDraft] }
        }

        const nextDrafts = [...state.boxSlotsBeingCreated]
        nextDrafts[existingDraftIndex] = boxSlotDraft
        return { boxSlotsBeingCreated: nextDrafts }
      })
    },
    updateBoxSlotsBeingCreated: (boxSlotDraft: BoxSlotDraftEntity) => {
      set((state) => {
        const existingDraftIndex = state.boxSlotsBeingCreated.findIndex((draft) => draft.id === boxSlotDraft.id)
        if (existingDraftIndex === -1) {
          return { boxSlotsBeingCreated: [...state.boxSlotsBeingCreated, boxSlotDraft] }
        }
        const nextDrafts = [...state.boxSlotsBeingCreated]
        nextDrafts[existingDraftIndex] = boxSlotDraft
        return { boxSlotsBeingCreated: nextDrafts }
      })
    },
    clearBoxSlotsBeingCreated: () => {
      set({ boxSlotsBeingCreated: [] })
    },
    addBoxSlotViewed: (boxSlotViewed: string) => {
      set({ boxSlotsBeingViewed: boxSlotViewed })
    },
    removeBoxSlotViewed: () => {
      set(() => ({
        boxSlotsBeingViewed: null,
      }))
    },
  },
}))

export const useBoxSlotsBeingCreated = () => useBoxPlanningStore((state) => state.boxSlotsBeingCreated)
export const useBoxSlotsBeingViewed = () => useBoxPlanningStore((state) => state.boxSlotsBeingViewed)
export const useBoxPlanningActions = () => useBoxPlanningStore((state) => state.actions)
